import React from 'react';
import {
  Box,
  IconButton,
  Modal as MuiModal,
  styled,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import {XIcon} from 'lucide-react';
import {DARK_TEXT_COLOR} from '../theme';

const StyledModal = styled(MuiModal)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  '> .MuiBox-root': {
    maxHeight: '90vh',
    overflow: 'auto',
    borderRadius: '0.5rem',
    boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.15)',
    backgroundColor: 'white',
  },
}));

const StyledHeading = styled(Typography)(() => ({
  fontSize: '1rem',
  fontWeight: '700',
  lineHeight: '120%',
  color: DARK_TEXT_COLOR,
}));

const StyledHeader = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: `${theme.spacing(1.5)} ${theme.spacing(3)}`,
  borderBottomWidth: '0.0625rem',
}));

export function Modal({open, onClose, title, children, width = 500}) {
  return (
    <StyledModal open={open} onClose={onClose}>
      <Box
        sx={{
          width,
          backgroundColor: 'white',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <StyledHeader>
          <StyledHeading>{title}</StyledHeading>
          <IconButton onClick={onClose}>
            <XIcon size={16} />
          </IconButton>
        </StyledHeader>
        {children}
      </Box>
    </StyledModal>
  );
}

Modal.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.any,
  width: PropTypes.number,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};
